export default {
  adults(state, adults) {
    state.adults = adults
  },
  children(state, children) {
    state.children = children
  },
  guests(state, guests) {
    state.guests = guests
  },
  rooms(state, rooms) {
    state.rooms = rooms
  },
  occupancy(state, occupancy) {
    state.occupancy = occupancy
  },
  checkInDate(state, checkInDate) {
    state.checkinDate = checkInDate
  },
  nonMemberRate(state, nonMemberRate) {
    state.nonMemberRate = nonMemberRate
  },
  checkOutDate(state, checkOutDate) {
    state.checkoutDate = checkOutDate
  },
  jsonHotel(state, jsonHotel) {
    state.jsonHotel = jsonHotel
  },
  jsonRooms(state, jsonRooms) {
    state.jsonRooms = jsonRooms
  },
  hotel(state, hotel) {
    state.hotel = hotel
  },
  nearbyHotels(state, nearbyHotels) {
    state.nearbyHotels = nearbyHotels
  },
  bookingStayInProgress(state, bookingStayInProgress) {
    state.bookingStayInProgress = bookingStayInProgress
  },
  customer(state, customer) {
    state.customer = customer
  },
  staysHasBeenLoading(state, staysHasBeenLoading) {
    state.staysHasBeenLoading = staysHasBeenLoading
  },
  exchangeRates(state, exchangeRates) {
    state.exchangeRates = exchangeRates
  },
  currenciesList(state, exchangeRates) {
    state.currenciesList = exchangeRates
  },
  tripAdvisorHotelInfo(state, tripAdvisorHotelInfo) {
    state.tripAdvisorHotelInfo = tripAdvisorHotelInfo
  },
  labelsLoaded(state, labelsLoaded) {
    state.labelsLoaded = labelsLoaded
  },
  loyaltyConsentAccepted(state, loyaltyConsentAccepted) {
    state.loyaltyConsentAccepted = loyaltyConsentAccepted
  },
  filter(state, filter) {
    state.filter = filter
  },
  filteredHotel(state, filteredHotel) {
    state.filteredHotel = filteredHotel
  },
  applyFilter(state, { filteredHotel, recalculatedFilter }) {
    state.filteredHotel = filteredHotel
    state.filter = recalculatedFilter
  },
  error(state, error) {
    state.error = error
  },
  setMembersBenefits(state, benefits) {
    state.membersBenefits = benefits
  },
  SET_DATA_QUBIT(state, labels) {
    state.dataQubit = labels
  },
  applyCurrency(state, currency) {
    state.filteredHotel = state.filteredHotel.changeCurrency(currency)
  },
  setToggleGroup(state, newValue) {
    state.toggleGroup = newValue
    state.toggleClass = state.toggleGroup ? 'active' : ''
  },
  setTabSelected(state, tab) {
    state.tabSelected = tab
  },
  setOccupancyByRooms(state, occupancies) {
    state.occupancyByRooms = occupancies
  },
  setNumberOfRoomsLeftByRoomId(state, numberOfRoomsLeftByRoomId) {
    state.numberOfRoomsLeftByRoomId = numberOfRoomsLeftByRoomId
  },
  setInitialNumberOfRoomsLeftByRoomId(state, initialValue) {
    state.initialNumberOfRoomsLeftByRoomId = initialValue
  },
  setselectedRoomId(state, newValue) {
    state.selectedRoomId = newValue
  },
  setselectedMealPlan(state, newValue) {
    state.selectedMealPlan = newValue
  },
  setselectedRateType(state, newValue) {
    state.selectedRateType = newValue
  },
  setSelectedId(state, newValue) {
    state.selectedId = newValue
  },
  setSelectedRoomCode(state, newValue) {
    console.log('setSelectedRoomCode', newValue)
    state.selectedRoomCode = newValue
  }
}
